import { useMemo } from 'react';

import { useSubscribableState, currentCostReviewTrackingId } from '../../subscribable-state';

export const useCurrentCostReviewTrackingId = (trackingId) => {
  const [currentAnalyticsSourceTrackingId, setCurrentAnalyticsSourceTrackingId] = useSubscribableState(
    currentCostReviewTrackingId(trackingId),
  );

  return useMemo(() => {
    return {
      currentAnalyticsSourceTrackingId,
      setCurrentAnalyticsSourceTrackingId,
    };
  }, [currentAnalyticsSourceTrackingId, setCurrentAnalyticsSourceTrackingId]);
};
